import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const HeadlineDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const HeadlineText = styled.span`
  margin-bottom: 8px;
  font-family: 'Averta', system-ui, sans-serif;
  font-size: var(--cc_size_text_l);
  font-weight: 600;
  color: var(--cc_color_text_default);
`;

const HeadlineDescription = styled.span`
  font-size: var(--cc_size_text_m);
  line-height: 20px;
  color: var(--cc_color_text_default);
`;

const Headline = ({ text, subtext, className }) => {
  return (
    <>
      <HeadlineDiv className={className}>
        <HeadlineText>{text}</HeadlineText>
        {!!subtext && <HeadlineDescription>{subtext}</HeadlineDescription>}
      </HeadlineDiv>
    </>
  );
};

Headline.propTypes = {
  text: PropTypes.object,
  subtext: PropTypes.object,
  className: PropTypes.string,
};

export default Headline;
